var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLowGarment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96733 4.15523C6.01526 3.67598 6.41854 3.31102 6.90018 3.31102H17.4106C17.8923 3.31102 18.2956 3.67598 18.3435 4.15523L19.845 19.1701C19.8713 19.4337 19.785 19.6961 19.6072 19.8925C19.4295 20.0888 19.177 20.2009 18.9121 20.2009H15.5338C15.1384 20.2009 14.7856 19.9529 14.6517 19.5809L12.1554 12.6469L9.65913 19.5809C9.52522 19.9529 9.17237 20.2009 8.77705 20.2009H5.39869C5.13381 20.2009 4.8813 20.0888 4.70357 19.8925C4.52584 19.6961 4.43948 19.4337 4.46584 19.1701L5.96733 4.15523ZM7.7486 5.18602L6.43461 18.3259H8.11815L11.2733 9.56154C11.4072 9.18958 11.7601 8.9416 12.1554 8.9416C12.5507 8.9416 12.9036 9.18958 13.0375 9.56154L16.1927 18.3259H17.8762L16.5622 5.18602H7.7486Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLowGarment);
export default __webpack_public_path__ + "static/media/icon-low-garment.381bc4260228c412250f6ec955105394.svg";
export { ForwardRef as ReactComponent };